export { default as PersonEditTemplate } from './PersonEdit';
export { default as PersonListTemplate } from './PersonList';
